// extracted by mini-css-extract-plugin
module.exports = {"login-form":"LoginForm_login-form__30TCa","msg-error":"LoginForm_msg-error__gq-pX","invalid":"LoginForm_invalid__2UqfS","input-message":"LoginForm_input-message__2jc8Z"};